import { Nav } from "@/components/marketing/Nav";
import { CtaFooter } from "@/components/marketing/CtaFooter";

const sections = [
  {
    title: "Who we are",
    body: "Cardio-Vascular Imaging (UK) Ltd (\"CVI\"), registered company number 8915015, is the data controller for personal information collected through this website. You can contact us via the contact form on this website.",
  },
  {
    title: "What we collect",
    body: "Contact form details (name, organisation, email, phone number and message); specialist portal account details (name, professional registration number, organisation and credentials); and referral information exchanged between verified specialists. Clinical case attachments are shared between authorised specialists only.",
  },
  {
    title: "How we use it",
    body: "To respond to enquiries, verify and manage specialist portal accounts, operate the referral service between clinicians, and improve the website. We do not sell personal data or use it for marketing without consent.",
  },
  {
    title: "How long we keep it",
    body: "Contact enquiries are retained for up to 12 months. Portal account and referral records are retained for as long as the account remains active, and are removed or anonymised on request, subject to any clinical governance obligations.",
  },
  {
    title: "Your rights",
    body: "You have the right to access, correct or erase your personal data, and to object to or restrict its processing. To exercise these rights, contact us via the contact form on this website. You may also complain to the Information Commissioner's Office (ICO) at ico.org.uk.",
  },
];

export default function Privacy() {
  return (
    <div className="bg-ivory min-h-screen" data-testid="privacy-page">
      <Nav />
      <div className="pt-32 pb-24 max-w-3xl mx-auto px-6">
        <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold mb-4">Legal</p>
        <h1 className="font-serif text-3xl lg:text-4xl font-semibold text-navy mb-10">Privacy notice</h1>
        <p className="text-sm text-navy/60 leading-relaxed mb-10">
          Last updated September 2026. Visiting this website does not make you a patient of
          Cardio-Vascular Imaging (UK) Ltd.
        </p>
        <div className="space-y-8">
          {sections.map((s) => (
            <div key={s.title} className="border-t border-navy/10 pt-6">
              <h2 className="font-serif text-xl font-semibold text-navy mb-3">{s.title}</h2>
              <p className="text-sm text-navy/60 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
      <CtaFooter />
    </div>
  );
}
